import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { currentUrl } from "url"

const baseUrl = currentUrl
const accessToken = localStorage.getItem("accessToken")

export const dentalChartApi = createApi({
  reducerPath: "dentalChartApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      // Получаем актуальный токен при каждом запросе
      const token = localStorage.getItem("accessToken")
      if (token) {
        headers.set("Authorization", `${token}`)
      }
      // Не устанавливаем Accept для FormData - браузер сам установит правильные заголовки
      return headers
    },
  }),
  endpoints: (builder) => ({
    // 1. Получить данные зубной карты клиента
    getClientDentalChart: builder.query({
      query: (salonClientId) => ({
        url: `/master/dental/charts/client/${salonClientId}`,
        method: "GET",
        headers: {
          "Accept": "application/json",
        },
      }),
    }),

    // 2. Получить данные конкретного зуба
    getToothData: builder.query({
      query: ({ salonClientId, toothNumber }) => ({
        url: `/master/dental/charts/client/${salonClientId}/tooth/${toothNumber}`,
        method: "GET",
        headers: {
          "Accept": "application/json",
        },
      }),
    }),

    // 3. Получить записи о процедурах (с фильтрацией)
    getToothRecords: builder.query({
      query: (params) => ({
        url: `/master/dental/tooth-records/search`,
        method: "GET",
        params,
        headers: {
          "Accept": "application/json",
        },
      }),
    }),

    // 4. Создать запись о процедуре (с медиафайлами)
    createToothRecordWithMedia: builder.mutation({
      query: (formData) => ({
        url: `/master/dental/tooth-records`,
        method: "POST",
        body: formData,
        // Не устанавливаем Content-Type - браузер сам добавит boundary для multipart/form-data
      }),
    }),

    // 5. Создать запись о процедуре (JSON, без медиа)
    createToothRecordJson: builder.mutation({
      query: (data) => ({
        url: `/master/dental/tooth-records`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),

    // 6. Обновить запись о процедуре (JSON)
    updateToothRecord: builder.mutation({
      query: ({ recordId, ...data }) => ({
        url: `/master/dental/tooth-records/${recordId}`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }),
    }),

    // 6b. Обновить запись о процедуре (с медиафайлами)
    updateToothRecordWithMedia: builder.mutation({
      query: ({ recordId, formData }) => ({
        url: `/master/dental/tooth-records/${recordId}`,
        method: "POST",
        body: formData,
        // Не устанавливаем Content-Type - браузер сам добавит boundary
      }),
    }),

    // 7. Удалить запись о процедуре
    deleteToothRecord: builder.mutation({
      query: (recordId) => ({
        url: `/master/dental/tooth-records/${recordId}`,
        method: "DELETE",
      }),
    }),

    // 8. Удалить медиафайл из записи
    deleteToothRecordMedia: builder.mutation({
      query: ({ recordId, mediaId }) => ({
        url: `/master/dental/tooth-records/${recordId}/media/${mediaId}`,
        method: "DELETE",
      }),
    }),
  }),
})

export const {
  useGetClientDentalChartQuery,
  useGetToothDataQuery,
  useGetToothRecordsQuery,
  useCreateToothRecordWithMediaMutation,
  useCreateToothRecordJsonMutation,
  useUpdateToothRecordMutation,
  useUpdateToothRecordWithMediaMutation,
  useDeleteToothRecordMutation,
  useDeleteToothRecordMediaMutation,
} = dentalChartApi
